import { render, staticRenderFns } from "./RecommendationDetail.vue?vue&type=template&id=2e1522ee&"
import script from "./RecommendationDetail.vue?vue&type=script&lang=ts&"
export * from "./RecommendationDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports